import {createListenerMiddleware, isAnyOf} from "@reduxjs/toolkit";

import {abTestingSelector} from "@pg-mono/ab-testing";
import {addABTestData} from "@pg-mono/ab-testing/src/actions/ab_testing_action";
import {buildABTestCookie} from "@pg-mono/ab-testing/src/utils/ab_testing_utils";

import {abTestingInstance} from "../../ab_testing/ab_testing_instance";
import {HidePricesVariant, OngoingABTests, ongoingABTests} from "../../ab_testing/ongoing_ab_tests";
import {rpInternalApiCookieDomain} from "../../app/read_rp_environment_variables";
import {IRootState} from "../../store/store";
import {authFailedButUnlockPrices} from "../actions/auth_failed_but_unlock_prices_event";
import {authSucceeded} from "../actions/auth_succeeded_event";

export const unlockHiddenPricesListener = createListenerMiddleware<IRootState>();

unlockHiddenPricesListener.startListening({
    matcher: isAnyOf(authSucceeded, authFailedButUnlockPrices),
    effect: async (action, listenerApi) => {
        const state = listenerApi.getState();
        const hidePricesAbTestConfig = abTestingInstance.getABTestContainerProps(OngoingABTests.HIDE_PRICES_AND_REGISTER);
        const currentAbTestVariant = abTestingSelector(hidePricesAbTestConfig.id)(state);

        if (currentAbTestVariant === HidePricesVariant.HIDDEN) {
            const abTestConfig = ongoingABTests.find((test) => test.name === OngoingABTests.HIDE_PRICES_AND_REGISTER);

            if (!abTestConfig) {
                return;
            }

            // Set cookie first for persistence across page reloads
            if (typeof document !== "undefined") {
                const cookieString = buildABTestCookie(abTestConfig.id, HidePricesVariant.HIDDEN_WITH_UNLOCK, abTestConfig.expires, rpInternalApiCookieDomain);
                document.cookie = cookieString;
            }

            // Update Redux store for immediate reactive UI changes
            listenerApi.dispatch(
                addABTestData({
                    id: abTestConfig.id,
                    variant: HidePricesVariant.HIDDEN_WITH_UNLOCK
                })
            );
        }
    }
});
import {createListenerMiddleware, isAnyOf} from "@reduxjs/toolkit";

import {abTestingSelector} from "@pg-mono/ab-testing";
import {addABTestData} from "@pg-mono/ab-testing/src/actions/ab_testing_action";
import {buildABTestCookie} from "@pg-mono/ab-testing/src/utils/ab_testing_utils";

import {abTestingInstance} from "../../ab_testing/ab_testing_instance";
import {HidePricesVariant, OngoingABTests, ongoingABTests} from "../../ab_testing/ongoing_ab_tests";
import {rpInternalApiCookieDomain} from "../../app/read_rp_environment_variables";
import {IRootState} from "../../store/store";
import {authFailedButUnlockPrices} from "../actions/auth_failed_but_unlock_prices_event";
import {authSucceeded} from "../actions/auth_succeeded_event";

export const unlockHiddenPricesListener = createListenerMiddleware<IRootState>();

unlockHiddenPricesListener.startListening({
    matcher: isAnyOf(authSucceeded, authFailedButUnlockPrices),
    effect: async (action, listenerApi) => {
        const state = listenerApi.getState();
        const hidePricesAbTestConfig = abTestingInstance.getABTestContainerProps(OngoingABTests.HIDE_PRICES_AND_REGISTER);
        const currentAbTestVariant = abTestingSelector(hidePricesAbTestConfig.id)(state);

        if (currentAbTestVariant === HidePricesVariant.HIDDEN) {
            const abTestConfig = ongoingABTests.find((test) => test.name === OngoingABTests.HIDE_PRICES_AND_REGISTER);

            if (!abTestConfig) {
                return;
            }

            // Set cookie first for persistence across page reloads
            if (typeof document !== "undefined") {
                const cookieString = buildABTestCookie(abTestConfig.id, HidePricesVariant.HIDDEN_WITH_UNLOCK, abTestConfig.expires, rpInternalApiCookieDomain);
                document.cookie = cookieString;
            }

            // Update Redux store for immediate reactive UI changes
            listenerApi.dispatch(
                addABTestData({
                    id: abTestConfig.id,
                    variant: HidePricesVariant.HIDDEN_WITH_UNLOCK
                })
            );
        }
    }
});
